import React, {useState, useEffect} from 'react';
import {
    AvailableTemplateBox,
    AvailableTemplateImg,
    AvailableTemplateText,
    AvailableTemplateWrapper,
    CurrentTemplateBox,
    CurrentTemplateImg,
    CurrentTemplateText,
    DisplayCenter,
    DisplayStart,
    LeftMenuItem, RedMessage,
    SearchInput,
    SwapBox,
    SwapBoxText,
    SwapItem
} from '../StyledComponents';
import {Box} from '@mui/material';
import {VscArrowSwap} from 'react-icons/vsc';
import {useDispatch, useSelector} from "react-redux";
import Button from '@mui/material/Button';
import {fabric} from "fabric";
import {
    createThumbnail,
    initSheets,
    modifiedImagesList,
    modifiedTemplateList,
    setCanvasBackground
} from "../../utils/helpers";
import {setActiveSheet} from "../../store/reducers/activeSheet";
import {setSheetList, updateSheetThumbnail} from "../../store/reducers/availableSheets";
import {getFabricCanvas} from "../../utils/canvasInitializer";
import {setFabricCanvasInstance} from "../../store/reducers/canvasSlice";
import LoadingButton from "@mui/lab/LoadingButton";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import {getAdminTemplateData, getImagesData} from "../../utils/apiHelper";
import {setUserImagesList} from "../../store/reducers/userImagesListSlice";
import {setTemplateDataList} from "../../store/reducers/templateDataSlice";
import {setLoading} from "../../store/reducers/modalToggler";


function SwapTemplateContent(props) {
    const savedAdminTemplates = useSelector((state) => state.templateDataList).templateDataList;
    const {canvas} = useSelector((state) => state.canvas);
    const activeSheet = useSelector((state) => state.activeSheet).sheet;
    const [activeTemplate, setActiveTemplate] = useState({index:0, item:{}})
    const [activeTemplateImage, setActiveTemplateImage] = useState('');
    const [btnLoading, setBtnLoading] = useState(false);
    const [noDataMsg, setNoDataMsg] = useState(false);

    const dispatch = useDispatch()

    useEffect(() => {
        setActiveTemplateImage(savedAdminTemplates[activeTemplate.index]?.cover)
    }, [activeTemplate])

    const initCanvas = (initialSheet) => {
        getFabricCanvas(initialSheet).then((newCanvas) => {
            if (initialSheet.objects) {
                fabric.util.enlivenObjects(initialSheet.objects, (objects) => {
                    canvas.add(...objects);
                    canvas.renderAll();
                });
            }
            dispatch(setFabricCanvasInstance(canvas));
            window.activeSheetId = initialSheet.id;
            window.activeSheet = initialSheet;
            window.canvas = canvas;
            createThumbnail(canvas).then((thumbnail) => dispatch(updateSheetThumbnail({
                sheetId: initialSheet.id,
                thumbnail,
            })));
            dispatch(setLoading(false))
        });
    };

    const loadStoredEditor = async () => {
        dispatch(setLoading(true))
        let storedActiveSheet = activeTemplate.item.canvasData
        let storedAvailableSheets = [activeTemplate.item.canvasData]
        const {newSheet, newSheetList, sheetBg} = await initSheets(storedAvailableSheets, storedActiveSheet);

        dispatch(setActiveSheet(newSheet));
        dispatch(setSheetList([...newSheetList]));
        initCanvas(newSheet);
        if(sheetBg)setCanvasBackground(canvas, sheetBg, dispatch, newSheet)
        props.setOpenSwapTemplateModal(false)
        props.resizeCanvas()
    };

    const handleTemplateClick = (item, index) => {
        setActiveTemplate({index, item})
    }

    const loadMoreTemplates = () => {
        setBtnLoading(true)
        getAdminTemplateData().then(async (res) => {
            const data = await modifiedTemplateList(res, activeSheet);
            dispatch(setTemplateDataList([...savedAdminTemplates, ...data]));
            setBtnLoading(false)
        })
            .catch(err=>{
                setNoDataMsg(true)
                setTimeout(() => {
                    setNoDataMsg(false);
                }, 4000);
                setBtnLoading(false)
            });
    }

    return (
        <>
            <Box sx={{display: 'table', width: '100%', height: '100%'}}>
                <Box sx={{
                    pt: 1,
                    pr: '30px',
                    pl: '7px',
                    width: '24%',
                    height: '100%',
                    borderRight: '1px solid #8e8f94',
                    display: 'table-cell',
                    verticalAlign: 'top'
                }}>
                    <SwapItem>
                        <SwapBox>
                            <LeftMenuItem>
                                <VscArrowSwap size={20} color="#38485D"/>
                                <SwapBoxText>Swap Template</SwapBoxText>
                            </LeftMenuItem>
                            <CurrentTemplateBox>
                                <CurrentTemplateText>Current Text</CurrentTemplateText>
                                <CurrentTemplateImg src="/images/SwapTemp.png"/>
                            </CurrentTemplateBox>
                        </SwapBox>
                    </SwapItem>
                    <SwapItem>
                        <DisplayCenter>
                            <Button onClick={loadStoredEditor} variant="outlined" size="medium">
                                Select Template
                            </Button>
                        </DisplayCenter>
                    </SwapItem>
                    <SwapItem>
                        <DisplayStart>
                            <SearchInput small type="text" placeholder='Search all templates'/>
                        </DisplayStart>
                    </SwapItem>

                    <div className="template-wrapper">
                        {savedAdminTemplates.map((item, index) => {
                            return <AvailableTemplateWrapper key={item.id}>
                                <AvailableTemplateBox bgImage={item?.cover} onClick={() => handleTemplateClick(item, index)}
                                                      className={index === activeTemplate.index ? "active-template" : null}>
                                    <AvailableTemplateText>{item?.title}</AvailableTemplateText>
                                </AvailableTemplateBox>
                            </AvailableTemplateWrapper>
                        })}
                        {noDataMsg && <RedMessage className="">No more data</RedMessage>}
                        <LoadingButton sx={{mt: 2}}
                                       onClick={loadMoreTemplates}
                                       loading={btnLoading}
                                       loadingPosition="end"
                                       endIcon={<PublishedWithChangesIcon />}
                                       variant="contained"
                        >
                            <span>Load more</span>
                        </LoadingButton>
                    </div>
                </Box>
                <Box sx={{width: '76%', height: '100%', display: 'table-cell'}}>
                    <DisplayCenter style={{height: '100%'}}>
                        <img src={activeTemplateImage} height="450" alt=""/>
                    </DisplayCenter>
                </Box>
            </Box>
        </>
    );
}

export default SwapTemplateContent;